var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 320,
  height: 192,
  viewBox: "0 0 320 192",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2597_11155",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 320,
  height: 192
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 320,
  height: 192,
  rx: 8,
  fill: "url(#paint0_linear_2597_11155)"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2597_11155)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 320,
  height: 192,
  rx: 8,
  fill: "url(#paint1_linear_2597_11155)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-6 0.581055L61.3855 96.9139L-6 193.245H31.6887L99.0742 96.9139L48.3162 24.6641H86.0049L136.558 96.9139L69.3774 193.245H182.442L249.623 96.9139L199.332 24.6641H237.018L287.311 96.9139L220.129 193.245H257.614L325 96.9139L257.614 0.581055H144.731L211.936 96.9139L161.381 169.161H123.897L174.247 96.9139L107.064 0.581055H-6Z",
  fill: "#532CF0",
  fillOpacity: 0.35
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2597_11155",
  x1: 160,
  y1: 0,
  x2: 160,
  y2: 192,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C5CE7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3454BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2597_11155",
  x1: 160,
  y1: 0,
  x2: 160,
  y2: 192,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C33B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A206A"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Logo.b474f2a6c46499a7d873b0c3d59ce221.svg";